const END_POINT = '/categories'

import BasicCrudAPI from './basicCrud.api.js'

const CategoryAPI = new BasicCrudAPI(END_POINT)

export default CategoryAPI
